<template>
    <NuxtLink v-if="item?.fields" :to="`${url}${item.id}`" class="neighborhood-square">
        <figure>
            <mess-image placeholder :src="coverImage || 'https://images.openhousechicago.org/email-header.png'" :alt="item.fields?.Name" :sizes="SIZES_NEIGHBORHOOD_SQUARE" />
            <div class="red-tag">
                <span>{{ siteQuantity }}</span> Sites
            </div>
            <SvgsSiteTour />
        </figure>
        <h3 v-html="item.fields?.Name || ''" class="headline-2"></h3>
    </NuxtLink>
</template>

<script setup>
    const { getImageFromArray } = useImageUrl();

    const props = defineProps({
        item: {
            type: Object,
            required: true,
            default: {},
        },
    });

    const { item } = toRefs(props);

    const coverImage = computed(() => {
        if (item.value?.fields?.['Cover Image']) {
            return getImageFromArray(item.value.fields['Cover Image'], 0);
        }
        return '';
    });

    // Same fix as Cards/neighborhood.vue (Asana O2-40): `Confirmed Sites Count`
    // is 0 on all 27 neighborhoods in Airtable, so this card printed "0 Sites"
    // on every tile of the neighborhoods index while the pages behind them
    // listed sites fine. That fix landed on the sibling card and missed this
    // one, which is why the index still read zero — count what the page will
    // actually show, from the same resolver.
    const { sitesData } = storeToRefs(useSitesStore());
    const siteQuantity = computed(() => neighborhoodSiteRecords(item.value, sitesData.value).length);

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/neighborhoods/';
        else return '/neighborhoods/';
    });
</script>

<style lang="scss" scoped>
    .neighborhood-square {
        h3 {
            word-break: break-word;
        }
    }
</style>
